import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { IPerson, selectPersonLoggedIn } from '../../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { getInitialsFromName } from '../../utils/miscUtils';
import { fetchIceServer } from '../../store/slices/chat';
import { P2PConnectionContext } from '../../context/P2PConnectionContext';
import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import logo from '../../assets/images/new-logo.svg';
import styles from './VideoCall.module.scss';
import BackButton from '../../components/UI/Buttons/BackButton';
import { useTranslation } from '../../hooks/useTranslations';
// import WithLoader from '../../components/WithLoader/WithLoader';

export default function StartVideoCall() {
  const personLoggedIn = useAppSelector<IPerson>(selectPersonLoggedIn);

  const { translations } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const testVideo = useRef<any>();
  const [testStream, setTestStream] = useState<any>();
  const [searchParams] = useSearchParams();
  let action = searchParams.get('action');
  let id = searchParams.get('id');

  const { stream, setStream, localAudio, localVideo, setLocalAudio, setLocalVideo } =
    useContext(P2PConnectionContext);

  const handleJoinVideoCall = () => {
    navigate(
      `/web/video-call?id=${id}&action=${action === 'initiate-answer' ? 'answer' : 'call'}`,
      {
        state: location.state,
      }
    );
  };

  const micToggle = () => {
    let audioTrack: any = testStream?.getTracks().find((track: any) => track.kind === 'audio');
    if (audioTrack.enabled) {
      setLocalAudio(false);
      audioTrack.enabled = false;
    } else {
      setLocalAudio(true);
      audioTrack.enabled = true;
    }
  };

  const videoToggle = () => {
    let videoTrack: any = testStream?.getTracks().find((track: any) => track.kind === 'video');
    if (videoTrack.enabled) {
      setLocalVideo(false);
      videoTrack.enabled = false;
    } else {
      setLocalVideo(true);
      videoTrack.enabled = true;
    }
  };

  useEffect(() => {
    dispatch(fetchIceServer());
    if (!('mediaDevices' in navigator) || !navigator.mediaDevices.getUserMedia) {
      console.log('mediaDevices error');
      return;
    }
    navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then((streamObj) => {
      testVideo.current.srcObject = streamObj;
      setStream(streamObj);
      setTestStream(streamObj);
    });
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBack = () => {
    if (testStream) {
      testStream.getTracks().forEach((track: any) => {
        track.stop();
      });
    }
    navigate(-1);
  };

  return (
    <div className={styles.videoContainer}>
      <div className={styles.header}>
        <img src={logo} alt="ecocareLogo" />
      </div>
      <div className={styles.backButton}>
        <BackButton
          onClick={() => handleBack()}
          style={{ background: '#fff', padding: '10px 25px' }}
        />
      </div>

      <div className={styles.startVideCallWrapper}>
        <div className={styles.card}>
          {/* <WithLoader isLoading={!iceServerData}> */}
          <p className={styles.title}>{translations('video.call')}</p>
          <video
            ref={testVideo}
            className={localVideo ? `${styles.video}` : `${styles.video} ${styles.hide}`}
            autoPlay
            playsInline
            muted
          />
          <div
            className={localVideo ? `${styles.emptyState} ${styles.hide}` : `${styles.emptyState}`}
          >
            <div className={styles.avatar}>
              {getInitialsFromName(
                `${personLoggedIn?.person_firstname + ' ' + personLoggedIn?.person_lastname}`
              )}
            </div>
          </div>
          <div className={styles.userInfoWrap}>
            <p>{`${personLoggedIn?.person_firstname} ${personLoggedIn?.person_lastname}`}</p>
            <div className={styles.btnWrap}>
              <button disabled={!stream} onClick={micToggle} className={`${styles.btn}`}>
                <i
                  className={`${localAudio ? styles.micOnIcon : styles.micOffIcon}`}
                  style={{ width: '40px', height: '40px' }}
                />
              </button>
              <button
                disabled={!stream}
                onClick={videoToggle}
                className={localVideo ? `${styles.btn}` : `${styles.btn} ${styles.red}`}
              >
                <i
                  className={localVideo ? styles.videoWhiteIcon : styles.videoOff}
                  style={{ width: '40px', height: '40px' }}
                />
              </button>
            </div>
          </div>
          <PrimaryButtonV2
            disabled={!testStream}
            text={translations('start.videocall')}
            onClick={handleJoinVideoCall}
            buttonStyle={{
              marginTop: '20px',
              width: '100%',
              fontSize: 14,
              height: 40,
            }}
          />
          {/* </WithLoader> */}
        </div>
      </div>
    </div>
  );
}
